import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Behavior } from '../../behavior';
import { BehaviorContext } from '../../behavior-context';
import {
  OTP_CONTACT_ID,
  OTP_LAYOUT_FACTORY_REF,
  PAGE_TEMPLATE_REF,
} from './otp-util';

@Injectable()
export class OtpVerifyCode implements Behavior {
  constructor(public http: HttpClient) {}

  async execute(
    args: {
      verifyCodeUrl: string;
      checkResumableUrl: string;
      enterCodeFormControlName: string;
      targetPageOnSuccess: string;
    },
    context: BehaviorContext
  ): Promise<any> {
    const otpLayoutFactory = context.get(OTP_LAYOUT_FACTORY_REF);
    const otpComponent = otpLayoutFactory.otpPageChild;
    const verifyCodeUrl = args.verifyCodeUrl;
    const checkResumableUrl = args.checkResumableUrl;
    const template = context.get(PAGE_TEMPLATE_REF);

    // Get the users entered code
    const codeControl = context.formGroup.get(args.enterCodeFormControlName);
    const codeValue = codeControl.value;

    // Get the user's stored contact info
    const contactId = context.get(OTP_CONTACT_ID);

    const payload = {
      authenticationId: contactId,
      code: codeValue,
    };

    try {
      const result: any = await this.http
        .put(verifyCodeUrl, payload)
        .toPromise();
      if (result.token) {
        // Check if resumable
        // Set cookie following ECOM pattern

        const resumeableResult: any = await this.http
          .get(`${checkResumableUrl}/checkoutsession/${btoa(contactId)}/resume`)
          .toPromise();

        if (resumeableResult.isAvailable) {
          otpComponent.uiService.codeState.next('userFound');
        } else {
          await template.goToPage(args.targetPageOnSuccess);
        }
      }
    } catch (error) {
      otpComponent.uiService.codeState.next('invalid');
      codeControl.markAsTouched();
      codeControl.markAsDirty();
      codeControl.setErrors({
        otpInvalidCode: true,
      });
    }
  }
}

@Injectable()
export class TestOtpVerifyCode implements Behavior {
  async execute(
    args: { [key: string]: any },
    context: BehaviorContext
  ): Promise<any> {
    const otpLayoutFactory = context.get(OTP_LAYOUT_FACTORY_REF);
    return new Promise(res => {
      setTimeout(() => {
        otpLayoutFactory.otpPageChild.uiService.codeState.next('userFound');
        res();
      }, 1500);
    });
  }
}
